<template>
  <el-form
    :key="formKey"
    label-position="top"
  >
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Megnevezés"
        >
          <el-input
            v-model="task.title"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Típus"
        >
          <el-select
            v-model="task.type"
            style="width: 100%;"
          >
            <el-option
              label="Disztribúciós felmérés"
              value="measure"
            />
            <el-option
              label="Képkészítés"
              value="photo"
            />
            <el-option
              label="Kérdőív"
              value="questionnaire"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item
      v-if="task.type === 'measure'"
      label="Kiválasztott termékek"
    >
      <el-select
        v-model="task.products"
        multiple
        filterable
        remote
        reserve-keyword
        :remote-method="fetchProducts"
        placeholder="Írd be az termék nevét a kereséshez..."
        :loading="loading"
        style="width: 100%;"
      >
        <el-option
          v-for="product in products"
          :key="product.id"
          :label="product.name"
          :value="product.id"
        />
      </el-select>
    </el-form-item>
    <questionnaire
      v-if="task.type === 'questionnaire'"
      ref="questionnaire"
      :question="task.question"
      :first="true"
    />
  </el-form>
</template>

<script>
import Questionnaire from './Questionnaire';

export default {
  components: { Questionnaire },
  props: ['item'],
  data() {
    return {
      formKey: 0,
      products: null,
      loading: false,
      task: {
        title: '',
        type: 'measure',
        products: [],
        question: {
          question: '',
          is_first_question: true,
          answers: [],
        },
      },
    };
  },
  methods: {
    async fetchProducts(query) {
      if (query !== '') {
        this.loading = true;
        this.products = await axios.get('/api/products/name/' + query);
        this.loading = false;
      }
    },
  },
};
</script>
